import React from 'react';
import CusButton from '../material-ui/CusButton';

export default function CasinoBtnSave({ onClick, sx, variant = 'contained', disabled }) {
  return (
    <CusButton
      fullWidth
      text="Save"
      variant={variant}
      onClick={onClick}
      sx={{ px: 5, ...sx }}
      disabled={disabled}
    />
  );
}
